import React from "react"
import {t} from "@lingui/core/macro"
import Meta from "../Meta"
import Header from "../header"
import Footer from "../footer"
import Loader from "../loader"
import ContentHub from "../../../components/ContentHub"

export default function UmmahContentHub({context, loading}) {
    const hub = context?.contentHub || {}
    const article = hub?.article

    const title = hub.view === "article" && article ? article.title : t`Explorer la bibliothèque`
    const description = hub.view === "article" && article
        ? (article.description || "")
        : t`Parcourez articles et catégories de contenu juif.`

    if (loading) {
        return (
            <div>
                <Meta context={context} title={title} description={description}/>
                <Loader/>
            </div>
        )
    }

    return (
        <div>
            <Meta context={context} title={title} description={description}/>
            <div id="main" className="main-content-wraper">
                <Header context={context}/>
                <ContentHub context={context}/>
                <Footer context={context}/>
            </div>
        </div>
    )
}
